import { render, staticRenderFns } from "./Delivery-Internal.vue?vue&type=template&id=3615c974"
import script from "./Delivery-Internal.vue?vue&type=script&lang=js"
export * from "./Delivery-Internal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports